interface DataComparisonProps<T> {
  title: string;
  existingData: T | undefined | null;
  newData: T;
  render: (value: T) => React.ReactNode;
}

export default function DataComparison<T>({
  title,
  existingData,
  newData,
  render,
}: DataComparisonProps<T>) {
  return (
    <div className="data-comparison">
      <div className="data-comparison-title">{title}</div>
      <div className="data-comparison-values">
        <div className="data-comparison-existing">
          <span>Existing Value</span>
          <span>{!!existingData ? render(existingData) : "N/A"}</span>
        </div>
        <div className="data-comparison-new">
          <span>New Value</span>
          <span>{render(newData)}</span>
        </div>
      </div>
    </div>
  );
}
